"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _FormControl = require("../FormControl/");
var _formControlState = _interopRequireDefault(require("../FormControl/formControlState"));
var _createStyles = require("../styles/createStyles");
const _excluded = ["textTransform"],
  _excluded2 = ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "required"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const useStyles = exports.useStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  const _theme$busbud$typogra = theme.busbud.typography.font.component.label.sm,
    {
      textTransform
    } = _theme$busbud$typogra,
    labelSm = (0, _objectWithoutProperties2.default)(_theme$busbud$typogra, _excluded);
  return {
    /* Styles applied to the root element. */
    root: _objectSpread(_objectSpread({}, labelSm), {}, {
      // Error on casting string to a valid textTransform value
      // TODO remove when legacy theme is removed
      textTransform: textTransform
    }),
    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},
    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},
    /* Styles applied to the asterisk element. */
    asterisk: {}
  };
});
/**
 * **❗️ DEPRECATED**
 *
 * A FormLabel displays content that is used to identify a form element.
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-api-formlabel--page)
 *
 * @deprecated
 */
const FormLabel = /*#__PURE__*/_react.default.forwardRef(function FormLabel(props, ref) {
  const {
      children,
      classes: classesOverrides,
      className,
      component: Component = 'label',
      disabled,
      error,
      filled,
      focused,
      required
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded2);
  const {
    classes,
    cx
  } = useStyles({
    classesOverrides
  });
  const dsFormControl = (0, _FormControl.useFormControl)();
  const fcs = (0, _formControlState.default)({
    props,
    dsFormControl,
    states: ['required', 'focused', 'disabled', 'error', 'filled']
  });
  return /*#__PURE__*/_react.default.createElement(Component
  // @ts-ignore TS2590
  , (0, _extends2.default)({
    className: cx(classes.root, className, {
      [classes.filled]: fcs.filled,
      [classes.required]: fcs.required,
      [classes.error]: fcs.error,
      [classes.focused]: fcs.focused,
      [classes.disabled]: fcs.disabled
    }),
    ref: ref
  }, other), children, fcs.required && /*#__PURE__*/_react.default.createElement("span", {
    className: cx(classes.asterisk, {
      [classes.error]: fcs.error
    })
  }, "\u2009", '*'));
});
var _default = exports.default = FormLabel;